"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerNotificationsContract = void 0;
const contract_1 = require("../base/contract");
const notifications_schemas_1 = require("../../schemas/customer/notifications.schemas");
const api_schemas_1 = require("../../schemas/base/api.schemas");
exports.CustomerNotificationsContract = (0, contract_1.createContract)({
    name: 'CustomerNotifications',
    baseUrl: '/me',
    version: '1',
    serviceModule: 'user',
    endpoints: {
        createFcmToken: {
            method: 'POST',
            path: '/fcm-tokens',
            body: notifications_schemas_1.createFcmTokenBodySchema,
            query: null,
            params: null,
            headers: null,
            response: {
                success: notifications_schemas_1.createFcmTokenResponseSchema,
                errors: {
                    unauthorized: api_schemas_1.baseErrorResponseSchema,
                    validationError: api_schemas_1.baseErrorResponseSchema,
                },
            },
            middleware: ['auth:required'],
            documentation: {
                summary: 'Register FCM push notification token',
                description: 'Registers or updates an FCM token for the authenticated user device',
                tags: ['Customer', 'Notifications'],
                deprecated: false,
            },
            tests: [
                'should register FCM token successfully',
                'should update existing token timestamp',
                'should return 401 for unauthenticated request',
            ],
        },
    },
});
